import React, { useEffect, useState } from "react";
import { logEvent } from "@Lib/analytics";
import styles from "./index.module.less";
import cx from "classnames";
import nl2br from "react-nl2br";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";

interface IProps {
  data: any;
  onChange: () => void;
}

const Introduction: React.FC<IProps> = (props: IProps) => {
  const { data, onChange } = props;
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
    onChange && onChange();
  };

  useEffect(() => {}, []);

  return (
    <section className={styles["Introduction"]}>
      <h1 className={styles["title"]}>{data.title}</h1>
      {data.intro && (
        <div className={styles["main"]}>
          <div className={cx(`${isExpanded ? styles["content"] : styles["pack-up"]}`)}>{nl2br(data.intro)}</div>
          {data.intro.length > 70 && (
            <div className={styles["icon"]} onClick={toggleExpansion}>
              {isExpanded ? (
                <CaretDownOutlined style={{ fontSize: "16px", color: "rgba(255, 255, 255, 0.5)" }} />
              ) : (
                <CaretUpOutlined style={{ fontSize: "16px", color: "rgba(255, 255, 255, 0.5)" }} />
              )}
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default Introduction;
